import React, { useState } from "react";

// region Language
import useTranslation from "@languages/useTranslation";
import { DeleteAccountMessages, SettingMessages } from "@languages/interfaces";
// endregion Language
// region Atoms
import CheckBox from "@atoms/CheckBox";
// endregion Atoms
// region Molecules
import PasswordForm from "@molecules/PasswordForm";
import OptionStep from "@molecules/OptionStep";
// endregion Molecules
// region Graphql
import { useMutation } from "@apollo/client";
import { TUserDeleteMutations, userDelete } from "@graphql/groups/user/mutation.graphql";
import { UserMutationsCustomDeleteArgs } from "@graphql/helpers/types.graphql";
// endregion Graphql
// region Libraries
import { useAuth } from "@hooks/useAuth";
import { useToast } from "@npm-telluria-tecnologia/telluria-ui";
// endregion Libraries
// region Styles
import * as Styled from "./styles";
// endregion Styles

const FormDeleteAccount: React.FC = () => {

  const { t } = useTranslation();
  const { addToast } = useToast();

  const {
    signOut,
    user,
    checkPassword
  } = useAuth();

  const [deleteAllData, setDeleteAllData] = useState(false);

  // Mutations
  const [MutationDeleteUser] = useMutation<TUserDeleteMutations,
    UserMutationsCustomDeleteArgs>(userDelete());

  /**
   * Delete user
   * @param email Email
   * @param password Password
   */
  const deleteAccount = async (email: string, password: string) => {
    const mutation = await MutationDeleteUser({
      variables: {
        user: {
          email,
          password
        }
      }
    });
  };

  // Handlers
  const handledelete = async (password: string) => {
    try {
      const correctPassword = await checkPassword({
        email: user.email,
        password
      });

      if (!correctPassword) {
        addToast({
          type: "error",
          title: t(SettingMessages.settingLoginVerificationFailed)
        });

        return;
      }
      await deleteAccount(user.email, password);
      signOut();
    } catch (error) {
      addToast({
        type: "error",
        title: t(DeleteAccountMessages.deleteAccountFailed)
      });
    }
  };

  const handleChangeDeleteAll = () => setDeleteAllData((state) => !state);

  return (
    <Styled.OptionContainer>
      <OptionStep
        number="1"
        title={t(DeleteAccountMessages.stepOne)}
      >
        <Styled.DescriptionText>
          {t(DeleteAccountMessages.description)}
        </Styled.DescriptionText>
      </OptionStep>
      <OptionStep
        number="2"
        title={t(DeleteAccountMessages.stepTwo)}
      >
        <CheckBox
          checked={deleteAllData}
          onClick={handleChangeDeleteAll}
          text={t(DeleteAccountMessages.checkConfirmDeletion)}
        />
      </OptionStep>
      <OptionStep
        number="3"
        title={t(DeleteAccountMessages.stepThree)}
      >
        <Styled.PasswordContainer>
          <PasswordForm
            onSubmit={handledelete}
            titleButton={t(DeleteAccountMessages.deleteButton)}
            actionConfirm={deleteAllData}
          />
        </Styled.PasswordContainer>
      </OptionStep>
    </Styled.OptionContainer>
  );
};

export default FormDeleteAccount;